import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { customTheme } from "./styles/theme";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import "./styles/custom.css";

// Hidden design credit, visible only in the browser console.
if (typeof window !== "undefined") {
  const brand =
    "background:linear-gradient(135deg,#2563EB,#06B6D4);color:#fff;padding:6px 12px;border-radius:6px;font-weight:700;font-size:12px;letter-spacing:0.5px;";
  const muted =
    "color:#64748B;font-size:11px;padding:6px 0 0 0;font-family:system-ui;";
  // eslint-disable-next-line no-console
  console.log("%cDesigned by Anselm Fowel × SlemTech", brand);
  // eslint-disable-next-line no-console
  console.log(
    "%chttps://anselmfowel.com  ·  https://slemtech.com",
    muted
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={customTheme.config.initialColorMode} />
    <ChakraProvider theme={customTheme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>,
);
